import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import apiBase from "../../utils/apiBase";

export interface PlaygroundModel {
  model: string;
  version: string;
  name: string;
  displayName: string;
  isToolsSupportEnabled: boolean;
}

const getPlaygroundModels = async (): Promise<any> => {
  const res = await apiBase.get(`models`, {
    headers: {
      "X-API-VERSION": "2.0",
    },
  });
  return res;
};

export const usePlaygroundModels = (): UseQueryResult<PlaygroundModel[]> => {
  return useQuery(["playgroundModels"], () => getPlaygroundModels());
};
